// 가로 카드 슬라이더 — 추천/인기 레터 등 횡스크롤 카드 캐러셀에 사용
//
// <div data-controller="components--card-slider">
//   <section class="splide ...">...</section>
// </div>
//
// values:
//   per-page:    lg+ (≥1024px) perPage. 기본 4
//   per-page-md: md (768~1023px) perPage. 기본 3
//   per-page-sm: sm (480~767px) perPage. 기본 2
//   per-page-xs: xs (<480px) perPage. 기본 1
//   gap:         카드 간격 (CSS 길이). 기본 "1rem"
//   loop:        끝에서 처음으로 순환할지 여부. 기본 true (rewind)

import { Controller } from "@hotwired/stimulus";
import Splide from "@splidejs/splide";

export default class extends Controller {
  static targets = ["slider"];
  static values = {
    perPage: { type: Number, default: 4 },
    perPageMd: { type: Number, default: 3 },
    perPageSm: { type: Number, default: 2 },
    perPageXs: { type: Number, default: 1 },
    gap: { type: String, default: "1rem" },
    loop: { type: Boolean, default: true },
  };

  connect() {
    const sliderEl = this.hasSliderTarget ? this.sliderTarget : this.element.querySelector(".splide");
    if (!sliderEl) return;

    this.slider = new Splide(sliderEl, {
      perPage: this.perPageValue,
      perMove: 1,
      gap: this.gapValue,
      pagination: false,
      arrows: true,
      rewind: this.loopValue,
      // 데스크탑/태블릿: padding 0 — 카드 좌우 끝이 섹션 헤더 등 주변 콘텐츠 정렬 라인과 일치한다.
      padding: 0,
      breakpoints: {
        1023: { perPage: this.perPageMdValue },
        767: {
          // sm: 2열 + 다음 카드 살짝 미리보기
          perPage: this.perPageSmValue,
          gap: "0.75rem",
          arrows: false,
          padding: { left: 0, right: "1rem" },
        },
        479: {
          // xs (모바일): 1열 + 다음 카드 살짝 미리보기
          perPage: this.perPageXsValue,
          gap: "0.75rem",
          arrows: false,
          padding: { left: 0, right: "1.25rem" },
        },
      },
    });
    this.slider.mount();
  }

  disconnect() {
    if (this.slider) {
      this.slider.destroy();
      this.slider = null;
    }
  }
}
